import { InfoCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Form,
  FormTitle,
  ShowInput,
  Tooltip,
  Wrapper,
  message,
  useBreadcrumbRoutes,
} from '@maxtropy/components';
import { ReactNode, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ALARM_LEVEL_CONFIG,
  MONITOR_OBJECT_TYPE_CONFIG,
  dispatchPointOptions,
  feedbackPointOptions,
} from '../constants';
import { getMockRule } from '../mockData';
import styles from '../Create/index.module.scss';

const infoLabel = (label: string, tip: ReactNode) => (
  <span className={styles.infoLabel}>
    {label}
    <Tooltip title={tip}>
      <InfoCircleOutlined className={styles.infoIcon} />
    </Tooltip>
  </span>
);

const getOptionLabel = (options: { label: string; value: string }[], value?: string) =>
  options.find(option => option.value === value)?.label ?? '--';

const DetailRule = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const rule = id ? getMockRule(Number(id)) : undefined;
  const goBack = () => navigate('/dispatch/control/deviation-rule');

  useEffect(() => {
    if (rule) {
      return;
    }

    message.warning('未找到该规则');
    navigate('/dispatch/control/deviation-rule', { replace: true });
  }, [navigate, rule]);

  if (!rule) {
    return null;
  }

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), { name: '查看规则' }]} hasPadding={false}>
      <main className={styles.page}>
        <FormTitle title="查看规则" className={styles.pageTitle} />
        <Form
          className={styles.form}
          layout="horizontal"
          labelAlign="left"
          labelCol={{ flex: '136px' }}
          wrapperCol={{ flex: 'auto' }}
          colon={false}
        >
          <Form.Item label="规则名称">
            <ShowInput value={rule.name || '--'} />
          </Form.Item>

          <Form.Item label="监听对象类型">
            <ShowInput value={MONITOR_OBJECT_TYPE_CONFIG[rule.monitorObjectType] ?? '--'} />
          </Form.Item>

          <Form.Item label="监听对象">
            <ShowInput value={rule.monitorObject || '--'} />
          </Form.Item>

          <Form.Item label={infoLabel('下发调度点位', '下发值来自调度系统实时下发的指令')}>
            <ShowInput value={getOptionLabel(dispatchPointOptions, rule.dispatchPoint)} />
          </Form.Item>

          <Form.Item label={infoLabel('回显监测点位', '回显值来自设备实际遥测数据')}>
            <ShowInput value={getOptionLabel(feedbackPointOptions, rule.feedbackPoint)} />
          </Form.Item>

          <Form.Item label="报警等级">
            <ShowInput value={ALARM_LEVEL_CONFIG[rule.alarmLevel]?.label ?? '--'} />
          </Form.Item>

          <Form.Item label="监听时间范围">
            <ShowInput value={rule.monitoringDuration ?? '--'} addonAfter="s" />
          </Form.Item>

          <Form.Item label={infoLabel('偏差率', '偏差率=(回显值-下发值)/下发值×100%')}>
            <ShowInput value={rule.deviationRate ?? '--'} addonAfter="%" />
          </Form.Item>

          <div className={styles.actions}>
            <Button onClick={goBack}>返回</Button>
          </div>
        </Form>
      </main>
    </Wrapper>
  );
};

export default DetailRule;
